import React from "react";
import { Globe, MapPin, Phone } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_maritime-solutions-10/artifacts/h1jjjufd_198E4AA3-70F6-4777-87F5-0FD635CD976A.png";

export default function BrandShowcase() {
  return (
    <section
      data-testid="brand-showcase-section"
      className="relative bg-white text-[#0A1128] overflow-hidden border-b border-gray-100"
    >
      <div className="absolute top-0 left-0 w-1.5 h-full bg-[#D90429]" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-14 sm:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          {/* Logo card */}
          <div className="lg:col-span-4 flex justify-center lg:justify-start">
            <div className="relative inline-block">
              <div className="bg-white p-3 sm:p-4 shadow-xl ring-1 ring-gray-200 transition-transform duration-500 hover:-translate-y-1">
                <img
                  src={LOGO_URL}
                  alt="KMS Services Plus - Logo officiel"
                  className="h-32 sm:h-40 w-auto object-contain"
                />
              </div>
              <div className="absolute -top-3 -right-3 bg-[#D90429] text-white text-[0.65rem] font-bold uppercase tracking-[0.2em] px-3 py-1.5">
                Officiel · CI
              </div>
            </div>
          </div>

          {/* Brand promise */}
          <div className="lg:col-span-5">
            <div className="kms-overline mb-3">Identité de marque</div>
            <h3 className="font-heading font-black text-2xl sm:text-3xl tracking-tight leading-tight text-[#0A1128]">
              L'excellence maritime <span className="text-[#D90429]">au service</span> de vos opérations.
            </h3>
            <p className="mt-4 text-[#6B7280] text-sm sm:text-base leading-relaxed max-w-md">
              KMS SP SARL — une marque ivoirienne dédiée à l'avitaillement
              maritime, la logistique et le commerce international.
            </p>
          </div>

          {/* Quick info */}
          <div className="lg:col-span-3 space-y-4 border-l-0 lg:border-l border-gray-200 lg:pl-8">
            <a
              href="https://www.kmsserviceplus.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="brand-website-link"
              className="flex items-start gap-3 group"
            >
              <Globe size={18} className="text-[#D90429] mt-0.5 flex-shrink-0" />
              <div>
                <div className="text-[0.65rem] uppercase tracking-[0.25em] text-[#9CA3AF] font-semibold">
                  Site web
                </div>
                <div className="font-heading font-bold text-base text-[#0A1128] group-hover:text-[#D90429] transition-colors">
                  www.kmsserviceplus.com
                </div>
              </div>
            </a>
            <a
              href="tel:+22505053527272"
              className="flex items-start gap-3 group"
            >
              <Phone size={18} className="text-[#D90429] mt-0.5 flex-shrink-0" />
              <div>
                <div className="text-[0.65rem] uppercase tracking-[0.25em] text-[#9CA3AF] font-semibold">
                  Tél
                </div>
                <div className="font-heading font-bold text-base text-[#0A1128] group-hover:text-[#D90429] transition-colors">
                  +225 05 05 35 27 27
                </div>
              </div>
            </a>
            <div className="flex items-start gap-3">
              <MapPin size={18} className="text-[#D90429] mt-0.5 flex-shrink-0" />
              <div>
                <div className="text-[0.65rem] uppercase tracking-[0.25em] text-[#9CA3AF] font-semibold">
                  Siège social
                </div>
                <div className="font-heading font-bold text-sm text-[#0A1128] leading-tight">
                  Abidjan · Treichville
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
